import { createAction, props } from '@ngrx/store';

import { INextPage } from '@web/gallery/core/models/gallery';
import { Preset } from '@live/reducers/live-presets.reducer';
import { IPresetDetails } from '@live/pages/live-ai-models-and-presets-page/tabs/live-presets-tab/components/apply-preset/interfaces';
import { IPresetError } from '@live/pages/live-ai-models-and-presets-page/live-preset-errors.class';
import { IUILiveInsightType, PresetsTab } from '@live/pages/live-ai-models-and-presets-page/interfaces';

import ICamera = Microsoft.VideoIndexer.Live.Contracts.ICamera;
import IPreset = Microsoft.VideoIndexer.Live.Contracts.IPreset;
import IPresetUpdate = Microsoft.VideoIndexer.Live.Contracts.IPresetUpdate;

export const loadPresets = createAction('[Live Presets/API] Load presets');
export const loadPresetsWithAffectedCamerasCount = createAction('[Live Presets/API] Load presets with affected cameras count');
export const loadPresetsNextPage = createAction('[Live Presets/API] Load presets next page');
export const loadPresetsWithAffectedCamerasCountNextPage = createAction('[Live Presets/API] Load presets with affected cameras count next page');

export const loadPresetsSuccess = createAction('[Live Presets/API] Loading presets success', props<{ presets: IPreset[]; nextPage?: INextPage }>());

export const getPreset = createAction('[Live Presets/API] Get preset', props<{ presetId: string }>());

export const getPresetSuccess = createAction('[Live Presets/API] Get preset success', props<{ preset: Preset }>());

export const getPresetFailed = createAction('[Live Presets/API] Get preset failed', props<{ error: IPresetError }>());

export const loadPresetsFailed = createAction('[Live Presets/API] Loading presets failed', props<{ error: IPresetError }>());

export const createPresetSuccess = createAction('[Live Presets/API] Create preset success', props<{ preset: Preset }>());

export const updatePreset = createAction('[Live Presets/API] Update preset', props<{ presetId: string; data: IPresetUpdate }>());

export const updatePresetSuccess = createAction('[Live Presets/API] Update preset success', props<{ preset: Preset }>());

export const updatePresetFailed = createAction('[Live Presets/API] Update preset failed', props<{ error: IPresetError }>());

export const getAffectedCamerasCountFailed = createAction('[Live Presets/API] Get affected cameras count failed', props<{ presetId: string }>());

export const createPreset = createAction('[Live Presets/API] Create preset', props<{ preset: IPresetUpdate }>());

export const createPresetFailed = createAction('[Live Presets/API] Create preset failed', props<{ error: IPresetError }>());

export const viewCamerasClicked = createAction('[Live Presets] View cameras by preset id', props<{ presetId: string; openInNewTab?: boolean }>());

export const viewAiInsightsClicked = createAction('[Live Presets] View AI Insights');

export const openCreatePresetDialog = createAction(
  '[Live Presets] Open create preset dialog',
  props<{ presetId: string; preselectedInsights?: IUILiveInsightType[] }>()
);

export const openEditPresetDialog = createAction('[Live Presets] Open edit preset dialog', props<{ presetId: string }>());

export const applyPreset = createAction('[Live Presets/API] Apply preset', props<{ presetId: string; cameraIds: ICamera['id'][] }>());

export const applyPresetBatchSuccess = createAction(
  '[Live Presets/API] Apply preset batch success',
  props<{ cameraIds: ICamera['id'][]; presetId: string }>()
);

export const applyPresetSuccess = createAction(
  '[Live Presets/API] Apply preset success',
  props<{ cameraId: ICamera['id']; presetId: ICamera['presetId'] }>()
);

export const applyPresetFailed = createAction(
  '[Live Presets/API] Apply preset failed',
  props<{ cameraId: ICamera['id']; presetId: ICamera['presetId']; error: IPresetError }>()
);

export const applyPresetBatchFailed = createAction(
  '[Live Presets/API] Apply preset batch failed',
  props<{ presetId: ICamera['presetId']; errors: { cameraId: ICamera['id']; error: IPresetError }[] }>()
);

export const managePresetsClicked = createAction('[Live Presets] Manage presets clicked');

export const openApplyPresetDialog = createAction('[Live Presets] Open apply preset dialog', props<{ cameras: ICamera[] }>());

export const presetTabSelected = createAction('[Live Presets] Select presets tab', props<{ tab: PresetsTab }>());

export const presetsTabChanged = createAction('[Live Presets] Presets tab changed', props<{ tab: PresetsTab }>());

export const openDeletePresetDialog = createAction('[Live Presets] Open delete preset dialog', props<{ presets: IPresetDetails[] }>());

export const deletePreset = createAction('[Live Presets/API] Delete preset', props<{ presetIds: string[] }>());

export const deletePresetBatchSuccess = createAction('[Live Presets/API] Delete preset batch success', props<{ presetIds: string[] }>());

export const deletePresetSuccess = createAction('[Live Presets/API] Delete preset success', props<{ presetId: string }>());

export const deletePresetFailed = createAction('[Live Presets/API] Delete preset failed', props<{ presetId: string; error: IPresetError }>());

export const deletePresetBatchFailed = createAction('[Live Presets/API] Delete preset batch failed', props<{ error: IPresetError }>());
